import React from "react";
import { getCategory } from "@/lib/categories";

export function CategoryPill({ category, size = "sm" }) {
  const c = getCategory(category);
  const sz = size === "sm" ? "text-xs px-2.5 py-1" : "text-sm px-3 py-1.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${c.chip} ${sz}`}
      data-testid={`category-pill-${c.key}`}
    >
      <span aria-hidden>{c.icon}</span>
      <span>{c.label}</span>
    </span>
  );
}
